import { connect } from "react-redux";
import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import UELoaderAnim from "../UELoaderAnim";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Styles from "./SubscriptionProducts.scss";

const SubscriptionProduct = ({ props }) => {
   const [isLoading, setIsLoading] = useState(false);
   const [currentDate, setCurrentDate] = useState(moment().year());
   const [monthProds, setMonthProds] = useState([]);

   const getProds = async (year = null) => {
      setIsLoading(true);
      let args = { year: year ?? currentDate };
      const result = await axios.post("/Api/Form_ref/stats/basic_pro_count", args);
      setMonthProds(
         result.data.data.map((item) => {
            return {
               id: item?.id,
               label: item?.label,
               prods: [
                  { type: "pro", count: item.prods[0]?.count },
                  {
                     type: item?.prods[1]?.type,
                     count: item?.prods[1]?.count,
                  },
               ],
            };
         })
      );
      setIsLoading(false);
   };

   const buildListDates = () => {
      let current = Number(moment().year());
      let dates = [];
      for (let i = current; i >= current - 5; i--) {
         dates.push(i);
      }
      return dates;
   };

   const listDates = buildListDates();


   useEffect(() => {
      getProds(currentDate);
   }, [currentDate]);

   const renderProdLine = (item) => {
      let total = item?.prods?.length ? item.prods.reduce((accum, current) => accum + current.count, 0) : null;

      const tooltip = (
         <Tooltip id="tooltip-top">
            {item.prods.map((prod, i) => (
               <div key={i}>
                  {prod.type} : {prod.count}
               </div>
            ))}
         </Tooltip>
      );

      return (
         <OverlayTrigger key={item.id} placement="top" overlay={tooltip}>
            <div className={"d-flex justify-content-between align-items-center ue-subscription-prod"}>
               <div className={"mr-2 font-weight-bolder ue-subscription-prod-month"}>{item.label}</div>
               <div className={"ue-subscription-prod-bg"}>
                  {item?.prods?.length && total
                     ? renderProd(total)
                     : // item.prods.map((prod, index) =>
                       //       prod?.count > 0
                       //           ? renderProd(prod, index, total)
                       //           : null
                       //   )
                       null}
               </div>
               <p
                  style={{
                     marginTop: "0",
                     marginBottom: "0",
                     fontSize: "10px",
                     paddingLeft: "5px",
                     fontWeight: "600",
                     paddingLeft: "12px",
                  }}
               >
                  {total}
               </p>
            </div>
         </OverlayTrigger>
      );
   };

   const renderProd = (total) => {
      return (
         <div className={"ue-subscription-prod2-bg"} style={{ width: ((100 / 10) * total) / 100 + "%" }}>
            <div className={"ue-subscription-prod-count text-center w-100"}>{total}</div>
         </div>
      );
   };

   return (
      <div className={"d-flex flex-column justify-content-start align-items-start rounded w-100 bg-white p-2"}>
         <div
            className={"d-flex justify-content-start align-items-center w-100"}
            style={{ padding: "5px 20px 5px 20px" }}
         >
            <div className={"mr-1"}>
               <svg width="26" height="23" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="26" height="23" rx="4" fill="#F1F4F4" />
                  <path
                     d="M16.8143 11.9275L11.6809 16.8229C11.4333 17.059 11.032 17.059 10.7844 16.8229L10.1857 16.2519C9.93852 16.0162 9.93805 15.6342 10.1846 15.398L14.2529 11.5L10.1846 7.60201C9.93805 7.36575 9.93852 6.98375 10.1857 6.74805L10.7844 6.17708C11.032 5.94097 11.4334 5.94097 11.6809 6.17708L16.8143 11.0725C17.0619 11.3086 17.0619 11.6914 16.8143 11.9275Z"
                     fill="#9A9A9A"
                  />
               </svg>
            </div>
            <div className={"ml-2 form-group mb-0"}>
               <select
                  id={"ue-form-select-date"}
                  className={"form-control"}
                  value={currentDate}
                  onChange={(e) => setCurrentDate(e.target.value)}
                  style={{
                     fontWeight: "800",
                     border: "none",
                     WebkitAppearance: "none",
                     MozAppearance: "none",
                     Appearance: "none",
                  }}
               >
                  {listDates ? (
                     listDates.map((item) => {
                        return (
                           <option key={item} value={item}>
                              Édition des formulaires : {item}
                           </option>
                        );
                     })
                  ) : (
                     <option value={currentDate}>{currentDate}</option>
                  )}
               </select>
            </div>
         </div>
         {isLoading ? (
            <div className="w-100 text-center">
               <UELoaderAnim size={30} />
            </div>
         ) : (
            <div
               className={"w-100 mt-4"}
               style={{
                  padding: "2px 23px 0px 23px",
               }}
            >
               {monthProds?.length ? (
                  monthProds.map((item) => renderProdLine(item))
               ) : (
                  <div className={"w-100 text center"}>Aucune référence de produit disponible</div>
               )}
            </div>
         )}
      </div>
   );
};
const mapStateToProps = (state) => {
   return {
      userId: state.MeReducer.id,
      username: state.MeReducer.username,
      role: state.MeReducer.role,
      structureInfo: state.SubscribtionReducer.structureInfo,
      entity: state.MeReducer.entity,
      currentSubscriptions: state.MeReducer.currentSubscription,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      updateUserInfo: (e) => dispatch({ type: "UPDATE_USER_STATUS", data: e }),
   };
};

export default connect(mapStateToProps, mapDispatchTProps)(SubscriptionProduct);
